import { reducer as about } from './modules/about';
import { reducer as absenteeBid } from './modules/absenteeBid';
import { reducer as addSearchAlert } from './modules/addSearchAlert';
import { reducer as analytics } from './modules/analytics';
import { reducer as auctionCalendar } from './modules/auctionCalendar';
import { reducer as auctionNews } from './modules/auctionNews';
import { reducer as autoPopModal } from './modules/autoPopModal';
import { bankAccount } from './modules/bankAccount';
import { bidderPreference } from './modules/bidderPreference';
import { catalogAdReducer } from '@/redux/modules/catalogAd/catalogAd.reducer';
import { catalogDetailReducer } from './modules/catalogDetail/catalogDetail.reducer';
import { catalogReducer } from '@/redux/modules/catalog/catalog.reducer';
import { reducer as certCapture } from './modules/certCapture';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { followSeller } from './modules/followSeller';
import { paginationCookiesReducer, paginationLocalStorageReducer } from './modules/pagination';
import { reducer as reseller } from './modules/reseller';
import { RootState } from './create';
import { savedSearch } from './modules/savedSearch';
import { wonItemsCountReducer } from './modules/wonItemsCount/wonItemsCount.reducer';
import apiPerformanceStats from './modules/apiPerformanceStats';
import auctionsNearMe from './modules/auctionsNearMe/auctionsNearMe';
import bidCountDown from './modules/bidCountDown';
import bidderBiddingInfoAll from './modules/bidderBiddingInfoAll';
import bidderCardStatus from './modules/bidderCardStatus';
import bidderExists from './modules/bidderExists';
import bidHistory from './modules/bidHistory';
import bidIncrements from './modules/bidIncrements';
import bidLimit from './modules/bidLimit';
import bidLimitExceeded from './modules/bidLimitExceeded';
import browser from './modules/browser';
import catalogAnnouncement from './modules/catalogAnnouncement';
import catalogCurators from './modules/catalogCurators';
import catalogItems from './modules/catalogItems';
import catalogLocation from './modules/catalogLocation';
import catalogRegistration from './modules/catalogRegistration';
import category from './modules/category';
import categoryCatalogCards from './modules/categoryCatalogCards';
import categoryRelatedSearches from './modules/categoryRelatedSearches';
import changePassword from './modules/changePassword';
import checkout from './modules/checkout';
import cityStateSuggestion from './modules/cityStateSuggestion';
import combinationCategory from './modules/combinationCategory';
import completeAccount from './modules/completeAccount';
import config from './modules/config';
import confirmPassword from './modules/confirmPassword';
import consent from './modules/consent';
import consignment from './modules/consignment';
import console from './modules/console';
import consoleBranding from './modules/consoleBranding';
import consoleMessages from './modules/consoleMessages';
import conversation from './modules/conversation';
import conversationFolders from './modules/conversationFolders';
import conversationMessages from './modules/conversationMessages';
import cookies from './modules/cookies';
import createAccount from './modules/createAccount';
import creditCard from './modules/creditCard';
import curatedCollection from './modules/curatedCollection';
import currency from './modules/currency';
import deleteAccount from './modules/deleteAccount';
import discover from './modules/discover';
import discoverPageSuggestions from './modules/discoverPageSuggestions';
import emailList from './modules/emailList';
import errors from './modules/errors';
import featuredCatalogs from './modules/featuredCatalogs';
import featuredCategories from './modules/featuredCategories';
import feedback from './modules/feedback';
import fetchBatch from './modules/fetchBatch';
import forgotPassword from './modules/forgotPassword';
import geoArea from '@/redux/modules/geoArea/geoArea';
import globalNotification from './modules/globalNotification';
import googleOptimize from './modules/googleOptimize';
import headerSearchDropdown from './modules/headerSearchDropdown';
import healthcheck from './modules/healthcheck';
import home from './modules/home';
import intl from './modules/intl';
import itemCardModel from './modules/itemCardModel';
import itemDetail from './modules/itemDetail';
import itemFacets from './modules/itemFacets';
import itemRemovalResponse from './modules/itemRemovalResponse';
import itemShipping from './modules/itemShipping';
import landingPage from './modules/landingPage';
import listingAgent from './modules/listingAgent';
import liveBid from './modules/liveBid';
import liveCatalogStatus from './modules/liveCatalogStatus';
import liveItemStatus from './modules/liveItemStatus';
import login from './modules/login';
import makeOffer from './modules/makeOffer';
import modal from './modules/modal';
import moreItemsFromCatalogIndex from './modules/moreItemsFromCatalogIndex';
import notification from './modules/notification';
import otherCategories from './modules/otherCategories/otherCategories';
import passwordReset from './modules/passwordReset';
import payment from './modules/payment';
import processingFee from './modules/processingFee';
import recentItem from './modules/recentItem';
import recommendedItem from './modules/recommendedItem';
import registerForCatalog from './modules/registerForCatalog';
import retractBid from './modules/retractBid';
import review from './modules/review';
import reviewStatus from './modules/reviewStatus';
import route from './modules/route';
import savedItemCount from './modules/savedItemCount';
import saveItem from './modules/saveItem';
import saveSearch from './modules/saveSearch';
import saveSearchCheck from './modules/saveSearchCheck';
import search from './modules/search';
import searchExclusions from './modules/searchExclusions';
import searchFacets from './modules/searchFacets';
import searchPromoted from './modules/searchPromoted';
import searchSuggestions from './modules/searchSuggestions';
import seller from './modules/seller';
import sellerCatalogCounts from './modules/sellerCatalogCounts';
import sellerDetail from './modules/sellerDetail';
import sellerEndedCatalogs from './modules/sellerEndedCatalogs';
import sellerFollowerCount from './modules/sellerFollowerCount';
import sellerPreviewCatalogs from './modules/sellerPreviewCatalogs';
import sellerRatings from './modules/sellerRatings';
import sellerRecordResults from './modules/sellerRecordResults';
import sellerUpcomingCatalogs from './modules/sellerUpcomingCatalogs';
import sendSellerMessage from './modules/sendSellerMessage';
import setPassword from './modules/setPassword';
import shipping from './modules/shipping';
import shippingQuote from './modules/shippingQuote';
import shouldLogin from './modules/shouldLogin';
import signifyd from './modules/signifyd';
import similarItems from './modules/similarItems';
import similarItemsCategories from './modules/similarItemsCategories';
import similarSoldItems from './modules/similarSoldItems';
import smsAlerts from './modules/smsAlerts';
import storefront from './modules/storefront';
import subcategoryTiles from './modules/subcategoryTiles';
import suggestedCategoryTiles from './modules/suggestedCategoryTiles';
import taxes from './modules/taxes';
import topRatedSellers from './modules/topRatedSellers';
import trustMetrics from './modules/trustMetrics';
import upcomingCatalogs from './modules/upcomingCatalogs';
import upcomingItems from './modules/upcomingItems';
import updateAccount from './modules/updateAccount';
import user from './modules/user';
import userVariantTest from './modules/userVariantTest';
import video from './modules/video';
import viewData from './modules/viewData';
import waitingForApproval from './modules/waitingForApproval';
import whiteLabel from './modules/whiteLabel';
import windowSize from './modules/windowSize';
import wonItems from './modules/wonItems';

export default (history: any) =>
    combineReducers({
        about,
        absenteeBid,
        addSearchAlert,
        analytics,
        apiPerformanceStats,
        auctionCalendar,
        auctionNews,
        auctionsNearMe,
        autoPopModal,
        bankAccount,
        bidCountDown,
        bidderBiddingInfoAll,
        bidderCardStatus,
        bidderExists,
        bidderPreference,
        bidHistory,
        bidIncrements,
        bidLimit,
        bidLimitExceeded,
        browser,
        catalog: catalogReducer,
        catalogAd: catalogAdReducer,
        catalogAnnouncement,
        catalogCurators,
        catalogDetail: catalogDetailReducer,
        catalogItems,
        catalogLocation,
        catalogRegistration,
        category,
        categoryCatalogCards,
        categoryRelatedSearches,
        certCapture,
        changePassword,
        checkout,
        cityStateSuggestion,
        combinationCategory,
        completeAccount,
        config,
        confirmPassword,
        consent,
        consignment,
        console,
        consoleBranding,
        consoleMessages,
        conversation,
        conversationFolders,
        conversationMessages,
        cookies,
        createAccount,
        creditCard,
        curatedCollection,
        currency,
        deleteAccount,
        discover,
        discoverPageSuggestions,
        emailList,
        errors,
        featuredCatalogs,
        featuredCategories,
        feedback,
        fetchBatch,
        followSeller,
        forgotPassword,
        geoArea,
        globalNotification,
        googleOptimize,
        healthcheck,
        home,
        intl,
        // item,
        itemCardModel,
        itemDetail,
        itemFacets,
        itemRemovalResponse,
        itemShipping,
        landingPage,
        listingAgent,
        liveBid,
        liveCatalogStatus,
        liveItemStatus,
        login,
        makeOffer,
        modal,
        moreItemsFromCatalogIndex,
        notification,
        otherCategories,
        pagination: paginationCookiesReducer,
        passwordReset,
        payment,
        persist: combineReducers({
            headerSearchDropdown,
            pagination: paginationLocalStorageReducer,
        }),
        processingFee,
        recentItem,
        recommendedItem,
        registerForCatalog,
        reseller,
        retractBid,
        review,
        reviewStatus,
        route,
        router: connectRouter(history),
        savedItemCount,
        savedSearch,
        saveItem,
        saveSearch,
        saveSearchCheck,
        search,
        searchExclusions,
        searchFacets,
        searchPromoted,
        searchSuggestions,
        seller,
        sellerCatalogCounts,
        sellerDetail,
        sellerEndedCatalogs,
        sellerFollowerCount,
        sellerPreviewCatalogs,
        sellerRatings,
        sellerRecordResults,
        sellerUpcomingCatalogs,
        sendSellerMessage,
        setPassword,
        shipping,
        shippingQuote,
        shouldLogin,
        signifyd,
        similarItems,
        similarItemsCategories,
        similarSoldItems,
        smsAlerts,
        storefront,
        subcategoryTiles,
        suggestedCategoryTiles,
        taxes,
        topRatedSellers,
        trustMetrics,
        upcomingCatalogs,
        upcomingItems,
        updateAccount,
        user,
        userVariantTest,
        video,
        viewData,
        waitingForApproval,
        whiteLabel,
        windowSize,
        wonItems,
        wonItemsCount: wonItemsCountReducer,
    });

export type GlobalState = RootState;
